import React from "react";
import { Link, Switch } from "react-router-dom";

import {
    MainContainer,
    MainTitle,
    TitleContainer,
    ColumnContainer,
    Column,
    Tabs,
} from "@beacharound/beacharound-ui";

import SubRoute from '../../components/Routes/SubRoute';

export default function Financial({ match, routes, location }) {
    
    const tabs = [{
        text: "Prenotazioni spiagge",
        component: Link,
        to: `${match.url}/reservations/beaches/private`,
    },{
        text: "Prenotazioni spiagge libere",
        component: Link,
        to: `${match.url}/reservations/beaches/public`,
    },{
        text: "Prenotazioni hotel",
        component: Link,
        to: `${match.url}/reservations/hotels`,
    },{
        text: "Preventivi hotel",
        component: Link,
        to: `${match.url}/quotations/hotels`,
    },{
        text: "Transazioni",
        component: Link,
        to: `${match.url}/transactions`,
    },{
        text: "Pagamenti",
        component: Link,
        to: `${match.url}/payments`,
    }]

    const tabsArray = tabs?.map((t) => t.to)

    return (
        <React.Fragment>
            <MainContainer large>
                <TitleContainer>
                    <MainTitle text="Financial" />
                </TitleContainer>

                <ColumnContainer noMargin>
                    <Column>
                        <Tabs list={tabs} activeIndex={tabsArray.indexOf(location.pathname)}/>
                    </Column>
                </ColumnContainer>

                <ColumnContainer>
                    <Column>
                        <Switch>
                            {routes?.map((page, index) => {
                                return <SubRoute key={index} {...page} />;
                            })}
                        </Switch>
                    </Column>
                </ColumnContainer>
            </MainContainer>
        </React.Fragment>
    );
}
